import moment from "moment";

export const convertToLocalTimezone = (date: string) => {
  const tz = moment.tz.guess();
  const utcDate = moment.tz(date, "Europe/Warsaw");
  const localTimezoneDate = utcDate.clone().tz(tz);

  return localTimezoneDate;
};
